import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { Row, Col } from '_zari/core'

import ProcesosSection from './procesosSection'
import ValidacioneSection from './validacionesSection'
import PaseInventariosSection from './paseInventariosSection'

const MainPage = () => {
  const __adminContext = React.useContext(AdminContext)

  return (
    <Row>
      <Col md={6}>
        <ProcesosSection />
      </Col>
      <Col md={6}>
        <ValidacioneSection />
      </Col>
      {__adminContext.flagPaseConsumos && (
        <Col md={6}>
          <PaseInventariosSection />
        </Col>
      )}
    </Row>
  )
}

export default React.memo(MainPage)
